import api from '../../utils/apiFetch';

const path = 'stats';

export default {
  getStats: (payload) => api.get(`${path}/enterprise`, payload),
  getOrgStats: (payload) => api.get(`${path}/orgstats`, payload),
};
